<template>
  <div class="layout">
    <div class="layout-nav">
      <slot name="nav"></slot>
    </div>
    <div class="margin" v-if="isMargin"></div>
    <div class="layout-main" :style="{ marginTop: isMargin ? '20px' : '0' }">
      <slot></slot>
    </div>
    <div class="layout-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isMargin: {
      type: Boolean,
      default: true
    }
  },
  name: "Layout"
};
</script>

<style scoped lang="scss">
@import "../../assets/style/var.scss";
$--container-padding: 20px;
.layout {
  width: 100%;
  height: 100vh;
  flex-direction: column;
  .layout-nav {
    width: 100%;
    z-index: 10;
  }
  .margin {
    width: 100%;
    height: 20px;
    background: #f3f5f7;
    position: fixed;
    top: $--nav-bar-height;
    left: 0;
    z-index: 5;
  }
  .layout-main {
    width: $--container-width;
    margin: 0px auto 0;
    // position: relative;
    // overflow-x: hidden;
    // overflow-y: auto;
    min-height: calc(100vh - #{$--nav-bar-height} - #{$--footer-height} - 20px);
  }
}
</style>
